import { loadedDatasourceStore } from "./storageKeys";
import { getTenant } from "./tenant";

interface LastLocation {
  projectId: string;
  estimateId: string;
  gcgrId: string;
  costModelId: string;
  contractingLoaded: boolean;
  tenant: string;
  url: string;
}

const webAppOrigin = (): string => `https://${getTenant() ?? ""}.ediphi.com`;

export const openExternalUrl = (url: string): void => {
  if (Office.context.requirements.isSetSupported("OpenBrowserWindowApi", "1.1")) {
    Office.context.ui.openBrowserWindow(url);
  } else {
    window.open(url, "_blank");
  }
};

const openWebApp = (path: string): void => {
  openExternalUrl(`${webAppOrigin()}${path}`);
};

export const getLastLocation = (): LastLocation => {
  const projectId = loadedDatasourceStore.get("selectedProjectId") || "";
  const estimateId = loadedDatasourceStore.get("selectedEstimateId") || "";
  const gcgrId = loadedDatasourceStore.get("selectedGcgrId") || "";
  const costModelId = loadedDatasourceStore.get("selectedCostModelId") || "";
  const contractingLoaded = loadedDatasourceStore.get("contractingLoaded") === "true";
  const tenant = getTenant() ?? "";
  const url =
    projectId && estimateId && tenant ? `${webAppOrigin()}/projects/${projectId}/estimates/${estimateId}` : "";

  return { projectId, estimateId, gcgrId, costModelId, contractingLoaded, tenant, url };
};

export function openEstimateInEdiphi(projectId: string, estimateId: string, options?: { calc?: boolean }) {
  openWebApp(`/projects/${projectId}/estimates/${estimateId}${options?.calc ? "?calc=true" : ""}`);
}

export function openGcgrInEdiphi(projectId: string, gcgrId: string) {
  openWebApp(`/projects/${projectId}/gcgrs/${gcgrId}/report`);
}

export function openContractingInEdiphi(projectId: string) {
  openWebApp(`/projects/${projectId}/internal-estimate`);
}

export function openCostModelInEdiphi(projectId: string, costModelId: string) {
  openWebApp(`/projects/${projectId}/costmodels/${costModelId}/view`);
}
